// Soft by Design -- shared header behavior (search, mobile menu)
// Safe to include on every page: every block below checks that its
// elements exist before wiring up listeners, so pages missing a piece
// (e.g. no newsletter form) won't throw errors.

document.addEventListener('DOMContentLoaded', function () {

  // ---- Live search against the real Shopify catalog (Predictive Search API) ----
  const searchToggle = document.getElementById('searchToggle');
  const searchPanel = document.getElementById('searchPanel');
  const searchInput = document.getElementById('searchInput');
  const searchResults = document.getElementById('searchResults');
  const searchFormEl = document.getElementById('searchForm');
  let searchDebounce;

  if (searchToggle && searchPanel && searchInput && searchResults && searchFormEl) {
    function showSearchMessage(text) {
      searchResults.innerHTML = '';
      const empty = document.createElement('div');
      empty.className = 'search-empty';
      empty.textContent = text;
      searchResults.appendChild(empty);
    }

    // The Predictive Search API (/search/suggest.json) returns each product's
    // price as a plain decimal string (e.g. "122.22"), NOT currency-formatted
    // -- unlike Liquid's `| money` filter used everywhere else on the site.
    // Previously this was rendered as-is, so search results showed "122.22"
    // instead of "$122.22". Formats it to match the rest of the site.
    function formatPrice(rawPrice) {
      const amount = parseFloat(rawPrice);
      if (isNaN(amount)) return rawPrice;
      return `$${amount.toFixed(2)}`;
    }

    async function runSearch(query) {
      const q = query.trim();
      if (!q) { searchResults.innerHTML = ''; return; }
      showSearchMessage('Searching...');
      try {
        const res = await fetch(`/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last`);
        const data = await res.json();
        const products = (data.resources && data.resources.results && data.resources.results.products) || [];
        searchResults.innerHTML = '';
        if (products.length === 0) {
          showSearchMessage(`No results for "${q}" — try a different word.`);
          return;
        }
        products.forEach(item => {
          const row = document.createElement('a');
          row.href = item.url;
          row.className = 'search-result-item';
          row.innerHTML = `<span>${item.title}</span><span class="price">${formatPrice(item.price)}</span>`;
          searchResults.appendChild(row);
        });
      } catch (err) {
        showSearchMessage('Search is unavailable right now — please try again.');
      }
    }

    searchToggle.addEventListener('click', () => {
      searchPanel.classList.toggle('open');
      if (searchPanel.classList.contains('open')) {
        searchInput.focus();
      }
    });
    searchInput.addEventListener('input', (e) => {
      clearTimeout(searchDebounce);
      const value = e.target.value;
      searchDebounce = setTimeout(() => runSearch(value), 250);
    });
    searchFormEl.addEventListener('submit', (e) => {
      e.preventDefault();
      window.location.href = `/search?q=${encodeURIComponent(searchInput.value)}&type=product`;
    });
    document.addEventListener('click', (e) => {
      if (!searchPanel.contains(e.target) && !searchToggle.contains(e.target)) {
        searchPanel.classList.remove('open');
      }
    });
  }

  // ---- Mobile nav menu toggle ----
  const menuBtn = document.querySelector('.nav-menu-btn');
  const navLinks = document.querySelector('.nav-links');
  if (menuBtn && navLinks) {
    menuBtn.addEventListener('click', () => {
      navLinks.classList.toggle('mobile-open');
    });
  }

  // ---- Newsletter form: NOTE -- the real submit handling (AJAX post +
  // Klaviyo list subscription + success message) lives in the inline
  // <script> at the bottom of sections/sbd-home.liquid, right next to the
  // form's own markup. This file used to also bind a second, leftover
  // "front-end only demo" submit listener to the same #nlForm element,
  // which fought with the real handler (overwriting the success message
  // and calling form.reset()) and was the source of a page-reload/flicker
  // bug on newsletter signup. Removed -- do not re-add a handler here.

  // ---- Cart quantity controls (cart page) ----
  document.querySelectorAll('[data-cart-qty-form]').forEach(form => {
    const input = form.querySelector('input[type="number"]');
    const minus = form.querySelector('[data-qty-minus]');
    const plus = form.querySelector('[data-qty-plus]');
    if (minus && input) {
      minus.addEventListener('click', () => {
        input.value = Math.max(0, parseInt(input.value || '1', 10) - 1);
        form.requestSubmit();
      });
    }
    if (plus && input) {
      plus.addEventListener('click', () => {
        input.value = parseInt(input.value || '1', 10) + 1;
        form.requestSubmit();
      });
    }
  });

  // ---- Product variant -> price/availability sync (product page) ----
  const variantSelect = document.querySelector('[data-variant-select]');
  if (variantSelect) {
    variantSelect.addEventListener('change', function () {
      const selected = this.options[this.selectedIndex];
      const price = selected.getAttribute('data-price');
      const available = selected.getAttribute('data-available') === 'true';
      const priceEl = document.querySelector('[data-product-price]');
      const addBtn = document.querySelector('[data-add-to-cart]');
      const idInput = document.querySelector('[data-variant-id-input]');
      if (priceEl && price) priceEl.textContent = price;
      if (idInput) idInput.value = this.value;
      if (addBtn) {
        addBtn.disabled = !available;
        addBtn.textContent = available ? 'Add to cart' : 'Sold out';
      }
    });
  }
});